import { z } from 'zod';
/** Dagelijkse KPI-snapshot per project (fase 4 MVP). */
export const kpiMetricsSchema = z.object({
    leads_total: z.number().int().min(0),
    leads_new: z.number().int().min(0),
    mails_sent: z.number().int().min(0),
    mails_bounce: z.number().int().min(0),
    mails_reply: z.number().int().min(0),
    reply_rate: z.number().min(0).max(1),
    bounce_rate: z.number().min(0).max(1),
    unsubscribes: z.number().int().min(0),
    campaigns_running: z.number().int().min(0),
});
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'from/to: ISO date YYYY-MM-DD');
function daysBetween(from, to) {
    const a = Date.parse(`${from}T00:00:00.000Z`);
    const b = Date.parse(`${to}T00:00:00.000Z`);
    return Math.round((b - a) / 86_400_000);
}
export const dashboardKpiQuerySchema = z
    .object({
    project_id: z.string().uuid().optional(),
    from: isoDate,
    to: isoDate,
})
    .superRefine((q, ctx) => {
    const span = daysBetween(q.from, q.to);
    if (span < 0) {
        ctx.addIssue({ code: 'custom', message: 'from must be on or before to', path: ['from'] });
    }
    else if (span > 90) {
        ctx.addIssue({ code: 'custom', message: 'Max range 90 days', path: ['to'] });
    }
});
export const dashboardMailHealthQuerySchema = z.object({
    project_id: z.string().uuid().optional(),
});
/** Zelfde datumbereik als KPI (max 90 dagen). */
export const dashboardGoogleQuerySchema = dashboardKpiQuerySchema;
//# sourceMappingURL=kpi.js.map